module.exports = __webpack_public_path__ + "img/kis_yes.e4fed86b.png";